import React, { useState }  from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import * as translator from "../../utils/translator";
import HeaderCMS from '../../components/Headers/HeaderCMS/HeaderCMS';
import SupportTicketSection from './components/SupportTicketSection';
import Footer from '../../components/Footer/Footer';
import StickyNotification from '../../components/StickyNotification/StickyNotification';
import Disclaimer from '../ChooseTreatmentVariants/components/Disclaimers/Disclaimer';
import ContactOrderIdForm from './components/ContactPageOrderInformationForm';
import ContactPageModal, { ContactPageModalData } from './components/ContactPageModal';
import LoginModal from '../../components/Modals/LoginModal/LoginModal';
import ForgotPasswordModal from '../../components/Modals/ForgotPasswordModal/ForgotPasswordModal';


const ContactPage = () => {
  const { country } = useParams();
  const language = translator.getLanguageByCountry(country!);
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [showLogInModal, setShowLogInModal] = useState<boolean>(false);
  const [showForgotPasswordModal, setShowForgotPassword] = useState(false);
  const [modalData, setModalData] = useState<ContactPageModalData>({
    orderHashID: "",
    orderTypes: [""],
    orderStatus: "",
    lastUpdated: "",
    shipmentTracking: "",
    shipmentNumber: "",
    pharmacyAdress: "",
    pharmacyName: "",
    pharmacyContact: "",
    daysInStatus: 0, 
    productName: "",
    case: "no_issue_with_order",
    isMedsConnectFrOrder: false
  });

  const [showStickyNotification, setShowStickyNotification] = useState({
    show: false,
    title: "",
    content: "",
    level: ""
  });  
  
  const navigationCallback = (pathname: string) => {
    navigate({
      pathname,
    },);
  };
  

  return (
    <>
      <StickyNotification
        title={showStickyNotification.title}
        content={showStickyNotification.content}
        onClick={() => setShowStickyNotification({ show: false, title: "", content: "", level: "error" })}
        key={5}
        level='error'
        showNotification={showStickyNotification.show}
        />
        {openModal && <ContactPageModal orderData={modalData} setOpenModal={setOpenModal} />}

      {showLogInModal && (
                  <LoginModal
                    setStickyNotificationDetails={() => {}}
                    closeModal={() => setShowLogInModal((current) => !current)}
                    navigationCallback={(exceededCategoryLimit : boolean, mention: string) => {
                      navigationCallback(``)
                    }
                    }
                    changeShowForgotPassword={(boolValue: boolean) => { setShowForgotPassword(boolValue) }}
                    language={language}
                    country={country}
                    message={translator.translate(
                                  language,
                                  "default",
                                  "LoginQuestion/login_message")}
                  />
                )}
      {showForgotPasswordModal && (
                  <ForgotPasswordModal
                    closeModal={() => setShowForgotPassword(false)}
                    language={language}
                    setStickyNotificationDetails={setShowStickyNotification}
                  />
                )}

      <HeaderCMS country={country!} />
      <div id='contact-page-container' className=' flex justify-center px-4 md:px-10 pt-10 gap-10 bg-[#F7F7F7] min-h-screen pb-[200px]'>
        <div id='contact-page' className='w-full max-w-[1400px] flex flex-col items-center' >

          <div className='w-full select-none'>
            <a onClick={() => navigate(-1)} className='text-left text-sm max-md:hidden text-[#269C6E] underline hover:no-underline cursor-pointer font-md '>
              {translator.translate(language, "contact", "ContactFormPage/back")}
            </a>
          </div>
          <h1 id='contact-form-title' className='font-poppins text-[#0D2C54] text-[24px] md:text-[32px] font-[500] md:leading-[48px] text-center py-10 w-full'>
            {translator.translate(language, "contact", "ContactFormPage/title")}{' '}
            <span className='contact-page-title-highlight'>{translator.translate(language, "contact", "ContactFormPage/title_highlight")}</span>
          </h1>
          <SupportTicketSection country={country!} language={language} />

          {country?.toUpperCase() === "DE" &&
            <div id='contact-page-disclaimer' className='pt-10 flex justify-center'>
              <Disclaimer 
              text={translator.translate(language, "contact", "HeaderMessage/disclaimer")}
              containerClassName='md:w-3/5'
              textClassName='font-[400]' />

            </div>
          }


          <ContactOrderIdForm setOpenModal={setOpenModal} setModalData={setModalData} setShowLogInModal={setShowLogInModal} toggleStickyNotification={setShowStickyNotification}/>
        </div>
      </div>

      <Footer page='questionnaire' />
    </>

  )
}

export default ContactPage